<div class="container-inco maint-exp-container">
  <div class="action-bar">
    <div class="action-buttons-left">
      <div class="project-combo">
        <app-searchable-select [items]="comboItems"
          bindLabel="displayLabel"
          bindValue="id"
          placeholder="Search project by ID or name"
          [(ngModel)]="selectedProjectId">
          <ng-template ng-option-tmp let-item="item">
            <b>{{item.displayLabel}}</b>
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            {{item.displayLabel}}
          </ng-template>
        </app-searchable-select>
      </div>
      <div class="fy-switcher">
        <span class="fy-switcher-hint">Change the FY visible window</span>
        <div class="fy-switcher-row">
          <app-fiscal-year-navigator [year]="centerFy"
            [min]="2020"
            [max]="2030"
            (yearChange)="onCenterFyChange($event)">
          </app-fiscal-year-navigator>
          <button mat-icon-button
            type="button"
            class="fy-reset-button"
            [disabled]="centerFy === currentFy"
            (click)="resetCenterFy()"
            matTooltip="Center on current fiscal year">
            <mat-icon>today</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="action-buttons-right">
      <div class="action-buttons-row">
        <a class="kpi-button-menu"
          [class.disabled]="selectedProjectId == null"
          title="Add project to table"
          (click)="selectedProjectId != null && addSelectedProject()">
          <span class="glyphicon glyphicon-plus"></span> Add
        </a>
        @if (editMode) {
          <a class="kpi-save-menu"
            [class.disabled]="hasInvalidValues()"
            [title]="hasInvalidValues() ? 'Fix invalid values before saving' : 'Save changes'"
            (click)="!hasInvalidValues() && onClickSave()">
            <span class="glyphicon glyphicon-floppy-disk"></span> Save
          </a>
        }
        <a class="kpi-button-menu"
          [class.disabled]="!editMode && rows.length === 0"
          [title]="editMode ? 'Discard changes and exit edit mode' : 'Edit values'"
          (click)="(editMode || rows.length > 0) && onClickEditUndo()">
          <span class="glyphicon glyphicon-pencil"></span>
          {{ editMode ? 'Undo' : 'Edit' }}
        </a>
      </div>
      @if (editMode && hasInvalidValues()) {
        <span class="validation-error">
          Some values are invalid. Each entry must be a number between 0 and 100 with at most {{ decimalPlaces }} decimal place{{ decimalPlaces === 1 ? '' : 's' }}.
        </span>
      }
    </div>
  </div>

  <app-data-table
    [columns]="columns"
    [groupedHeaders]="groupedHeaders"
    [data]="rows"
    [editMode]="editMode"
    [transparent]="true"
    [alternateRowColors]="true"
    [highlightOnHover]="false"
    [emptyMessage]="'No projects added yet. Use the search above to add one.'"
    (cellValueChange)="onCellValueChange($event)">
    <ng-template #cellTemplate let-row let-column="column">
      @if (column.key === 'actions') {
        <div class="action-buttons-cell">
          <button mat-icon-button
            class="action-icon-button delete-button"
            matTooltip="Remove project"
            (click)="removeRow(row.id); $event.stopPropagation()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }
      @if (column.key !== 'actions') {
        {{ formatCellValue(row, column) }}
      }
    </ng-template>
  </app-data-table>
</div>
